const translations = {
  "en": {
    "Enter your code": "Enter your code",
    "Enter your code to claim exclusive membership benefits and Aura rewards": "Enter your code to claim exclusive membership benefits and Aura rewards",
    "Redeem Rewards": "Redeem Rewards"
  },
  "zh-tw": {
    "Enter your code": "輸入您的代碼",
    "Enter your code to claim exclusive membership benefits and Aura rewards": "輸入您的代碼以領取專屬會員權益與 Aura 獎勵。",
    "Redeem Rewards": "兌換回饋"
  }
};

export default translations;
